import { useEffect, useState } from 'react'
import { ErrorBoundary } from '../components/ErrorBoundary'
import { HealPage } from './HealPage'
import { verifyHealAccess } from './healApi'
import '../styles/heal.css'

export function HealRoot() {
  const [state, setState] = useState<'loading' | 'allowed' | 'denied'>('loading')
  const [localMode, setLocalMode] = useState(false)

  useEffect(() => {
    verifyHealAccess()
      .then(access => { setLocalMode(access.local_mode); setState('allowed') })
      .catch(() => setState('denied'))
  }, [])

  if (state === 'loading') return <main className="heal-gate" role="status" aria-live="polite"><p>Verifying access…</p></main>
  if (state === 'denied') return <main className="heal-gate"><h1>Page not found</h1><p>The requested page is unavailable.</p></main>
  return <ErrorBoundary><HealPage localMode={localMode} /></ErrorBoundary>
}
